import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "size-5",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 19l-7-7 7-7",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Go Back", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "border max-w-4xl mx-auto p-4 my-8" }
const _hoisted_6 = { class: "text-center mb-4 bg-secondary-gray dark:bg-gray-800 py-4" }
const _hoisted_7 = { class: "sm:text-7xl text-4xl font-bold mt-6" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-center items-center gap-4 mt-2\"><a href=\"/Ogbaje_Leo_Arome.pdf\" class=\"w-[170px] lg:h-[48px] h-[38px] my-2 flex gap-4 justify-center items-center border-2 border-r-4 border-b-4 border-black dark:border-gray-500 hover:shadow-lg hover:scale-105 rounded-md cursor-pointer\" download=\"Ogbaje_Leo_Arome\" target=\"_blank\" rel=\"noopener noreferrer\">Resume<span class=\"group-hover:rotate-270 duration-300\"><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"size-6\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3\"></path></svg></span></a></div>", 1)
const _hoisted_9 = { class: "text-2xl font-bold" }
const _hoisted_10 = { class: "mb-6 border-t-2 py-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold" }, "About Me", -1)
const _hoisted_12 = { class: "sm:text-lg text-sm py-4" }
const _hoisted_13 = { class: "mb-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Core Technologies", -1)
const _hoisted_15 = { class: "mb-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Familiar With", -1)
const _hoisted_17 = { class: "mb-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "On The Job", -1)
const _hoisted_19 = { class: "mb-6 border-y-2 py-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Experience", -1)
const _hoisted_21 = { class: "text-2xl font-bold" }
const _hoisted_22 = { class: "text-lg font-semibold" }
const _hoisted_23 = { class: "text-lg font-medium" }
const _hoisted_24 = { class: "list-disc list-inside px-3" }
const _hoisted_25 = { class: "mb-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Strength", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold" }, "Leadership", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold mt-2" }, "Problem Solving", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold mt-2" }, "Collaboration", -1)
const _hoisted_30 = { class: "mb-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Education", -1)
const _hoisted_32 = { class: "text-xl font-bold" }
const _hoisted_33 = { class: "text-lg font-semibold" }
const _hoisted_34 = { class: "text-md" }
const _hoisted_35 = { class: "text-gray-600 dark:text-gray-400" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Projects", -1)

import AppFooter from "@/components/AppFooter.vue";
import AppNavbar from "@/components/AppNavbar.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeView',
  setup(__props) {

const router = useRouter();

const goBack = () => {
  if (router.currentRoute.value.fullPath !== "/") {
    router.back();
  } else {
    // Optional: handle the case where there's no history, e.g., redirect to a default route
    router.push("/");
  }
};

const fullName = ref("Ogbaje Leo Arome");
const jobTitle = ref("Frontend Engineer");
const about = ref(
  `A highly committed, consistent, and resilient individual with a drive to create exceptional user experiences through the use of HTML, CSS, Javascript, ReactJs, VueJs, and other technologies seeking a position to leverage strong technical and problem-solving skills and extensive web development knowledge to achieve organizational efficiency, reduce page load speeds, and optimize user interfaces `
);
const coreTechnologies = ref(
  `HTML/CSS, Tailwindcss, Javascript [ES6], ReactJs, NextJs, Vue Js, CSS-in-JS, Git, Redux, Github, Figma,  `
);
const familiarWith = ref(`Typescript, Node Js,  PWAs, SEO.`);
const onTheJob = ref(`Version Control, Best Practices`);
const experiences = ref([
  {
    company: "SFx",
    position: "Lead Frontend Engineer",
    duration: "Feb 2025 - Present",
    highlights: [
      "Designed and developed user-friendly, responsive interfaces for the platform using modern web technologies, ensuring seamless interaction and a positive user experience.",
      "Collaborated closely with product designers and backend engineers to deliver innovative features and integrate APIs for cross-border transactions, savings accounts, and card spending.",
      "Implemented best practices in performance optimization, security, and accessibility to meet high standards of the fintech industry.",
      "Led the team in adopting agile methodologies, ensuring efficient project delivery while maintaining a strong focus on meeting client needs and business goals.",
      "Played a key role in scaling the platform to support a growing user base while maintaining a high level of code quality and system reliability.",
    ],
  },
  {
    company: "OnlyMed",
    position: "Frontend Developer",
    duration: "Aug 2025 - Dec 2025",
    highlights: [
      "Spearheaded the end-to-end development and seamless integration of a high-performance admin dashboard, drastically accelerating operational workflows.",
      "Engineered dynamic, highly responsive user interfaces that empowered administrators with real-time data insights and streamlined management.",
      "Architected robust, scalable frontend solutions, ensuring an exceptional, seamless experience for internal stakeholders.",
    ],
  },
  {
    company: "FunNTail",
    position: "Frontend Engineer (Freelancing)",
    duration: "Oct 2025 - Present",
    highlights: [
      "Working remotely as a freelance frontend engineer, delivering high-quality user interfaces and interactive web applications.",
      "Collaborating with cross-functional teams to implement responsive designs and ensure optimal user experiences.",
      "Utilizing modern frontend technologies to build scalable and maintainable solutions.",
    ],
  },
  {
    company: "Gen6ixxx Venture",
    position: "Frontend Engineer (Freelancing)",
    duration: "June 2025 - Present",
    highlights: [
      "Working remotely as a freelance frontend engineer, developing and maintaining web applications for the venture.",
      "Implementing modern UI/UX designs and ensuring cross-browser compatibility and responsive layouts.",
      "Contributing to project success through efficient code delivery and adherence to best practices.",
    ],
  },
  {
    company: "Trendx",
    position: "Frontend Engineer",
    duration: "Jan 2025 - March 2025",
    highlights: [
      "Developed a decentralized autonomous organization (DAO) platform for businesses using React, enhancing transparency and governance.",
      "Implemented key frontend features, including smart contract interactions, user authentication, and data visualization for DAO operations.",
      "Optimized application performance and ensured a seamless user experience across devices through efficient state management and UI optimizations.",
      "Collaborated with backend developers to integrate blockchain technologies and enhance the security of the platform.",
    ],
  },
  {
    company: "Queryfier LLC",
    position: "Frontend Developer",
    duration: "Jan 2024 - Jan 2025",
    highlights: [
      "Collaborated with a team of developers to build a document validation and evaluation system with AI functionalities using Vue.js and related libraries.",
      "Designed and implemented user interface features for document validation, evaluation, and AI integration.",
      "Ensured responsiveness and optimized performance of the application for a seamless user experience",
      "Successfully delivered the project within established timelines, showcasing strong project management skills and commitment to meeting client requirements.",
    ],
  },

  {
    company: "TIIDELab Initiative",
    position: "Frontent Developer ",
    duration: "June 2023 - December 2023",
    highlights: [
      "Played a pivotal role in the development and implementation of INsure, a cutting-edge insurance sales management application designed to streamline lead tracking and enhance the efficiency of insurance agents.",
      "Leveraged expertise in front-end technologies, including HTML, CSS, JavaScript, and React to create an intuitive and visually appealing user interface, contributing significantly to a positive user experience.",
      "Demonstrated a keen understanding of industry best practices, adhering to coding standards, and implementing responsive design principles to guarantee a consistent and engaging experience across various devices.",
      "Successfully delivered the project within established timelines, showcasing strong project management skills and commitment to meeting client requirements.",
    ],
  },
]);
const education = ref([
  {
    institution: "Federal Polytechnic Idah",
    discipline: "HND Computer Science",
    grade: "Distinction",
    section: "2019-2022",
  },

]);
const strength = ref({
  leadership:
    "Led a team of developers and successfully delivered multiple projects on time and within budget.",
  problem:
    "Identified and resolved complex technical issues resulting in improved application performance.",
  collaboration:
    "Worked closely with cross-functional teams to gather requirements and ensure successful project implementation.",
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppNavbar),
    _createElementVNode("button", {
      onClick: goBack,
      class: "flex items-center justify-start gap-3 max-w-[95vw] sm:max-w-[754px] xl:max-w-[1240px] mx-auto font-semibold w-full md:text-base text-sm mt-4 md:hidden"
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, _toDisplayString(fullName.value), 1),
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, _toDisplayString(jobTitle.value), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString(about.value), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", null, _toDisplayString(coreTechnologies.value), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("p", null, _toDisplayString(familiarWith.value), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("p", null, _toDisplayString(onTheJob.value), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experiences.value, (experience) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "py-4",
            key: experience.company
          }, [
            _createElementVNode("h3", _hoisted_21, _toDisplayString(experience.company), 1),
            _createElementVNode("h3", _hoisted_22, _toDisplayString(experience.position), 1),
            _createElementVNode("p", _hoisted_23, _toDisplayString(experience.duration), 1),
            _createElementVNode("ul", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experience.highlights, (point) => {
                return (_openBlock(), _createElementBlock("li", { key: point }, _toDisplayString(point), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _hoisted_27,
        _createElementVNode("p", null, _toDisplayString(strength.value.leadership), 1),
        _hoisted_28,
        _createElementVNode("p", null, _toDisplayString(strength.value.problem), 1),
        _hoisted_29,
        _createElementVNode("p", null, _toDisplayString(strength.value.collaboration), 1)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(education.value, (edu) => {
          return (_openBlock(), _createElementBlock("div", {
            key: edu.institution,
            class: "mb-4"
          }, [
            _createElementVNode("h3", _hoisted_32, _toDisplayString(edu.institution), 1),
            _createElementVNode("p", _hoisted_33, _toDisplayString(edu.discipline), 1),
            _createElementVNode("p", _hoisted_34, _toDisplayString(edu.grade), 1),
            _createElementVNode("p", _hoisted_35, _toDisplayString(edu.section), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _hoisted_36,
        _createVNode(_component_router_link, {
          to: "/projects",
          class: "py-4 cursor-pointer font-semibold my-3 underline"
        }, {
          default: _withCtx(() => [
            _createTextVNode("See Projects ...")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(AppFooter)
  ]))
}
}

})